module.exports = __webpack_public_path__ + "static/img/timetable_widget_2.354b9fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/timetable_widget_2.png
// module id = 7OB+
// module chunks = 11